import { Dispatchable, useAppDispatch } from "../..";
import { LoadingStatusCode } from "../types/LoadingStatusCode";
import { checkNotLoaded } from "../utils/checkLoadingStatus";

/**
 * Диспатч с проверкой загруженности. Если загружено, то не загружается
 */

export const useDispatchWithCheck = () => {
  const dispatch = useAppDispatch();

  const dispatchWithCheck = (action: Dispatchable, loadingStatusCode: LoadingStatusCode) => {
    if (checkNotLoaded(loadingStatusCode)) {
      dispatch(action);
    }
  };
  return { dispatchWithCheck };
};
